import { render } from "./side-bar.vue?vue&type=template&id=2926b3e6"
import script from "./side-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./side-bar.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/layouts/main-layout/components/side-bar/side-bar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2926b3e6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2926b3e6', __exports__)) {
    api.reload('2926b3e6', __exports__)
  }
  
  module.hot.accept("./side-bar.vue?vue&type=template&id=2926b3e6", () => {
    api.rerender('2926b3e6', render)
  })

}


export default __exports__